export default function Loading() {
    return (<div className="loading ph10"><p>Loading...</p></div>);
}